import i18n from "../../../language/i18n";
import { Icon } from "../../../library";
import { assignmentKindDef } from "../../../utilization/AssignmentKindUtilization";

/**
 * The KIND marker every merged ödev row carries — "Şube ödevi" / "Destek ödevi" /
 * "Bireysel ödev" / "Sınav".
 *
 * Since Çalışmalar was folded into Ödevler, one list mixes four kinds; without this the
 * learner cannot tell which teacher surface a row came from, and the row's route (they
 * differ per kind) reads as arbitrary. Product requirement, not decoration.
 *
 * Renders as an uppercase EYEBROW, sized to sit on a card's meta rail (.qdd-hw-rail /
 * .qdf-hw-rail / .qak-item-rail) on its own line above the ders name — it used to be a
 * coloured 9px pill inline with the 17px/700 subject line, where it both read as a
 * footnote and collided with the coterie palette. See AssignmentKindChipStyles.ts for
 * the hue measurement that took the colour away.
 *
 * Renders `null` for a type the app does not model as an ödev — an unlabeled row beats a
 * row labelled with a guess. Callers placing this in a rail must therefore not assume it
 * produced a node: a rail whose other slot is also optional needs a guard (see
 * .qdf-hw-rail's), and one that right-aligns its other slot must do so with
 * `margin-left: auto` rather than `justify-content: space-between`, which would park
 * that slot on the left when the kind is absent.
 *
 * Its CSS (`akc-`) lives in the shared components aggregator, injected ONCE in App.tsx:
 * this renders per ROW, so a local `<style>` would be duplicated dozens of times in a
 * long list.
 */
const AssignmentKindChip = ({ type }: { type?: string | null }) => {
  const def = assignmentKindDef(type);
  if (!def) return null;
  return (
    <span className={`akc-chip akc-chip--${def.modifier}`}>
      <Icon name={def.iconName} size={13} />
      {i18n.t(def.labelKey)}
    </span>
  );
};

export default AssignmentKindChip;
